import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="PaymentFooter">
      <div className="PaymentFooterInner">
        <div className="PaymentFooterBrand">
          <img
            className="PaymentFooterLogo"
            src="logo_poziom2_b.png"
            alt="GuideHub logo"
          />
          <p className="PaymentFooterCopy">
            Private tours with secure payment and a booking flow that stays easy
            to review on mobile and desktop.
          </p>
        </div>

        <div className="PaymentFooterLinks">
          <div className="PaymentFooterColumn">
            <span className="PaymentFooterHeading">Legal</span>
            <a
              href="https://app.guidehub.eu/#/privacyPolicy"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
            <a
              href="https://app.guidehub.eu/#/termsOfService"
              target="_blank"
              rel="noreferrer"
            >
              Terms of Service
            </a>
          </div>

          <div className="PaymentFooterColumn">
            <span className="PaymentFooterHeading">Support</span>
            <a href="mailto:kamil@guidehub.eu">kamil@guidehub.eu</a>
            <a href="tel:+48537578312">+48 537 578 312</a>
          </div>
        </div>
      </div>

      <div className="PaymentFooterBottom">
        <span>Copyright {year} GuideHub</span>
        <span>All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
